import { RouteRecordRaw } from 'vue-router';

const creditCheck: RouteRecordRaw = {
  path: '/building-stack/tenant-screening-promo',
  name: 'BuildingStackCreditCheckPromo',
  component: () => import('@/views/building-stack/CreditCheckPromo.vue'),
  meta: {
    auth: { required: true, permissions: ['admin'] },
    title: 'Building Stack Credit Check Promo',
    active: false,
    icon: 'fas fa-user-check',
  },
};

const rentalApplications: RouteRecordRaw = {
  path: '/building-stack/rental-applications-promo',
  name: 'BuildingStackRentalApplicationsPromo',
  component: () => import('@/views/building-stack/RentalApplicationsPromo.vue'),
  meta: {
    auth: { required: true, permissions: ['admin'] },
    title: 'Building Stack Rental Applications Promo',
    active: false,
    icon: 'fas fa-user-check',
  },
};

const rentalApplicationsSF: RouteRecordRaw = {
  path: '/building-stack/rental-applications-promo-sf',
  name: 'BuildingStackRentalApplicationsPromoSF',
  component: () => import('@/views/building-stack/RentalApplicationsPromoSF.vue'),
  meta: {
    auth: { required: true, permissions: ['admin'] },
    title: 'Building Stack Rental Applications Promo SF',
    active: false,
    icon: 'fas fa-user-check',
  },
};

const onlinePayments: RouteRecordRaw = {
  path: '/building-stack/online-payments-promo',
  name: 'BuildingStackOnlinePaymentsPromo',
  component: () => import('@/views/building-stack/OnlinePaymentsPromo.vue'),
  meta: {
    auth: { required: true, permissions: ['admin'] },
    title: 'Building Stack Online Payments Promo',
    active: false,
    icon: 'fas fa-user-check',
  },
};

export const buildingStackRoutes = [
  creditCheck,
  rentalApplications,
  rentalApplicationsSF,
  onlinePayments,
];
